(function() {
  'use strict';

  console.log('[Upsell] script loaded');

  var pendingVariantId = null;
  var lastPointerHandled = 0;

  function getMoneyFormat() {
    var wrapper = document.querySelector('[data-cart-upsell]');
    if (wrapper && wrapper.getAttribute('data-money-format')) {
      return wrapper.getAttribute('data-money-format');
    }
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.symbol) {
      return window.Shopify.currency.symbol + '{{amount}}';
    }
    return '{{amount}}';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, getMoneyFormat());
    }
    return (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function getUpsellVariantId() {
    var wrapper = document.querySelector('[data-cart-upsell]');
    if (!wrapper) return null;
    var btn = wrapper.querySelector('[data-upsell-add-to-cart]');
    if (!btn) return null;
    return btn.dataset.variantId || btn.dataset.productId || null;
  }

  function syncCartUI() {
    if (!document.querySelector('[data-cart-upsell]')) return;
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var cartCountElements = document.querySelectorAll('.cart-count, .cart-icon__count, .header__cart-count, .js-cart-count');
        cartCountElements.forEach(function(el) {
          el.textContent = cart.item_count;
        });

        var cartTotalElements = document.querySelectorAll('.cart-total, .cart-drawer__total, .js-cart-total');
        cartTotalElements.forEach(function(el) {
          var priceEl = el.querySelector('.price, .money, .total-price');
          if (priceEl) {
            priceEl.textContent = formatMoney(cart.total_price);
          } else {
            el.textContent = formatMoney(cart.total_price);
          }
        });

        var variantId = getUpsellVariantId();
        var wrapper = document.querySelector('[data-cart-upsell]');
        if (wrapper && variantId) {
          var inCart = cart.items.some(function(item) { return item.id == variantId; });
          wrapper.style.display = inCart ? 'none' : '';
        }
      })
      .catch(function(e) { console.log('Error syncing cart UI:', e); });
  }

  function refreshCartDrawer() {
    if (window.cartDrawer && typeof window.cartDrawer.update === 'function') {
      window.cartDrawer.update();
    }
    if (window.ajaxCart && typeof window.ajaxCart.update === 'function') {
      window.ajaxCart.update();
    }
    if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.CartDrawer && typeof Shopify.theme.CartDrawer.updateCart === 'function') {
      try {
        Shopify.theme.CartDrawer.updateCart();
      } catch (e) {
        // Silently fail
      }
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart-updated'));
    document.dispatchEvent(new CustomEvent('ajaxCart:update'));

    fetch('/cart?section_id=cart-drawer')
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var currentBody = document.getElementById('MinimogCartDrawerBody');
        if (currentBody) {
          var newBody = doc.getElementById('MinimogCartDrawerBody');
          if (newBody) currentBody.innerHTML = newBody.innerHTML;
        }
        var currentFooter = document.getElementById('MinimogCartDrawerFooter');
        if (currentFooter) {
          var newFooter = doc.getElementById('MinimogCartDrawerFooter');
          if (newFooter) currentFooter.innerHTML = newFooter.innerHTML;
        }
        syncCartUI();
      })
      .catch(function(e) {
        console.log('Error refreshing cart drawer:', e);
        syncCartUI();
      });
  }

  function addProduct(variantId, properties, btn, onSuccess) {
    btn.disabled = true;
    btn.classList.add('loading');

    var failSafe = setTimeout(function() {
      btn.disabled = false;
      btn.classList.remove('loading');
    }, 15000);

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    Object.keys(properties).forEach(function(key) {
      fd.append('properties[' + key + ']', properties[key]);
    });

    fetch('/cart/add', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: fd
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) {
            throw new Error(err.description || 'Failed to add product');
          });
        }
        return response.json().catch(function() { return {}; });
      })
      .then(function() {
        clearTimeout(failSafe);
        if (onSuccess) onSuccess();
        refreshCartDrawer();
      })
      .catch(function(error) {
        console.error('Error adding upsell product:', error);
        clearTimeout(failSafe);
        btn.disabled = false;
        btn.classList.remove('loading');
        if (onSuccess) {
          var errorEl = document.querySelector('[data-upsell-popup-error]');
          if (errorEl) {
            errorEl.textContent = error.message || 'Failed to add product';
            errorEl.style.display = 'block';
          }
        } else {
          var buttonText = btn.querySelector('.button-text');
          if (buttonText) {
            var originalText = buttonText.textContent;
            buttonText.textContent = 'Error!';
            setTimeout(function() {
              buttonText.textContent = originalText;
            }, 2000);
          }
        }
      });
  }

  function showPopupError(message) {
    var errorEl = document.querySelector('[data-upsell-popup-error]');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = 'block';
    }
  }

  function openPopup() {
    var overlay = document.querySelector('[data-upsell-popup-overlay]');
    if (!overlay) return false;
    var fileInput = overlay.querySelector('[data-upsell-photo-input]');
    var preview = overlay.querySelector('[data-upsell-photo-preview]');
    var textInput = overlay.querySelector('[data-upsell-text-input]');
    var errorEl = overlay.querySelector('[data-upsell-popup-error]');
    if (fileInput) fileInput.value = '';
    if (preview) preview.style.display = 'none';
    if (textInput) textInput.value = '';
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
    overlay.style.display = 'flex';
    return true;
  }

  function closePopup() {
    var overlay = document.querySelector('[data-upsell-popup-overlay]');
    if (overlay) overlay.style.display = 'none';
    pendingVariantId = null;
  }

  function handleAddButtonClick(addToCartBtn) {
    var variantId = addToCartBtn.dataset.variantId || addToCartBtn.dataset.productId;
    if (!variantId) {
      console.error('Upsell handler error: no variant ID found on button', addToCartBtn);
      return;
    }
    console.log('[Upsell] Add clicked, variantId =', variantId);
    var overlay = document.querySelector('[data-upsell-popup-overlay]');
    if (overlay && overlay.dataset.enabled === 'true') {
      pendingVariantId = variantId;
      if (openPopup()) return;
    }
    addProduct(String(variantId), {}, addToCartBtn);
  }

  function handleConfirmClick() {
    var overlay = document.querySelector('[data-upsell-popup-overlay]');
    if (!overlay || !pendingVariantId) return;

    var photoInput = overlay.querySelector('[data-upsell-photo-input]');
    var textInput = overlay.querySelector('[data-upsell-text-input]');
    var photoKey = overlay.getAttribute('data-photo-key') || 'Photo';
    var textKey = overlay.getAttribute('data-text-key') || 'Text';
    var photoRequired = overlay.getAttribute('data-photo-required') === 'true';
    var textRequired = overlay.getAttribute('data-text-required') === 'true';

    var hasPhoto = photoInput && photoInput.files && photoInput.files.length > 0;
    var hasText = textInput && textInput.value.trim() !== '';

    if (photoRequired && !hasPhoto) {
      showPopupError('Please upload a photo');
      return;
    }
    if (textRequired && !hasText) {
      showPopupError('Please enter your text');
      return;
    }

    var properties = {};
    if (hasPhoto) properties[photoKey] = photoInput.files[0];
    if (hasText) properties[textKey] = textInput.value.trim();

    var confirmBtn = overlay.querySelector('[data-upsell-popup-confirm]');
    if (!confirmBtn) return;

    addProduct(String(pendingVariantId), properties, confirmBtn, function() {
      closePopup();
    });
  }

  function closestInPath(selector, path) {
    if (path) {
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (el && el.closest) {
          var match = el.closest(selector);
          if (match) return match;
        }
      }
    }
    return null;
  }

  function getEventPath(e) {
    return typeof e.composedPath === 'function' ? e.composedPath() : null;
  }

  function getOverlay(path) {
    return closestInPath('[data-upsell-popup-overlay]', path) || document.querySelector('[data-upsell-popup-overlay]');
  }

  function onDocumentClick(e) {
    try {
      if (Date.now() - lastPointerHandled < 500) return;
      var path = getEventPath(e);
      var overlay = getOverlay(path);

      if (overlay && overlay.style.display === 'flex') {
        if (closestInPath('[data-upsell-popup-close]', path) || closestInPath('[data-upsell-popup-cancel]', path) || e.target === overlay) {
          e.preventDefault();
          e.stopPropagation();
          closePopup();
          return;
        }
        if (closestInPath('[data-upsell-popup-confirm]', path)) {
          e.preventDefault();
          e.stopPropagation();
          handleConfirmClick();
          return;
        }
      }

      var addToCartBtn = closestInPath('[data-upsell-add-to-cart]', path);
      if (!addToCartBtn) return;

      console.log('[Upsell] click on add button');
      e.preventDefault();
      e.stopPropagation();
      handleAddButtonClick(addToCartBtn);
    } catch (err) {
      console.error('Upsell handler error:', err);
    }
  }

  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener('click', onDocumentClick, false);

  document.addEventListener('pointerdown', function(e) {
    try {
      var path = getEventPath(e);
      var overlay = getOverlay(path);

      if (overlay && overlay.style.display === 'flex') {
        if (closestInPath('[data-upsell-popup-confirm]', path)) {
          lastPointerHandled = Date.now();
          console.log('[Upsell] pointerdown confirm');
          handleConfirmClick();
          return;
        }
        if (closestInPath('[data-upsell-popup-close]', path) || closestInPath('[data-upsell-popup-cancel]', path) || e.target === overlay) {
          lastPointerHandled = Date.now();
          closePopup();
          return;
        }
      }

      var btn = closestInPath('[data-upsell-add-to-cart]', path);
      if (!btn) return;

      lastPointerHandled = Date.now();
      console.log('[Upsell] pointerdown add');
      handleAddButtonClick(btn);
    } catch (err) {
      console.error('Upsell handler error:', err);
    }
  });

  function bindUpsellButtons() {
    document.querySelectorAll('[data-upsell-add-to-cart]').forEach(function(btn) {
      if (btn.dataset.upsellBound) return;
      btn.dataset.upsellBound = '1';
      btn.addEventListener('click', function(e) {
        if (Date.now() - lastPointerHandled < 500) return;
        console.log('[Upsell] direct click on add button');
        e.preventDefault();
        e.stopPropagation();
        handleAddButtonClick(btn);
      });
    });

    var wrapper = document.querySelector('[data-cart-upsell]');
    if (wrapper && !wrapper.dataset.upsellBound) {
      wrapper.dataset.upsellBound = '1';
      wrapper.addEventListener('click', function(e) {
        if (Date.now() - lastPointerHandled < 500) return;
        if (!(e.target instanceof Element)) return;
        var btn = e.target.closest('[data-upsell-add-to-cart]');
        if (!btn) return;
        console.log('[Upsell] wrapper-delegated click');
        e.preventDefault();
        e.stopPropagation();
        handleAddButtonClick(btn);
      });
    }
  }

  bindUpsellButtons();
  console.log('[Upsell] add buttons found:', document.querySelectorAll('[data-upsell-add-to-cart]').length);

  var rebindTimer;
  new MutationObserver(function(mutations) {
    var added = false;
    mutations.forEach(function(m) {
      if (m.type === 'childList' && m.addedNodes.length) added = true;
    });
    if (!added) return;
    clearTimeout(rebindTimer);
    rebindTimer = setTimeout(function() {
      bindUpsellButtons();
      syncCartUI();
    }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  setInterval(function() {
    bindUpsellButtons();
  }, 700);

  document.addEventListener('change', function(e) {
    if (!e.target.matches('[data-upsell-photo-input]')) return;
    var overlay = document.querySelector('[data-upsell-popup-overlay]');
    var preview = overlay ? overlay.querySelector('[data-upsell-photo-preview]') : null;
    if (e.target.files && e.target.files.length > 0) {
      if (preview) {
        var img = preview.querySelector('img');
        img.src = URL.createObjectURL(e.target.files[0]);
        preview.style.display = 'block';
      }
    } else if (preview) {
      preview.style.display = 'none';
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closePopup();
  });

  syncCartUI();
})();